import React, {Component} from "react";
import BaseBtn from "../../Buttons/BaseBtn";
import * as AdminClassroomService from "../../../services/Teacher/AdminClassroomService";
import * as AdminHomeworkService from "../../../services/Teacher/AdminHomeworkService";
import * as Utils from "../../Utils";
import PopupAlert from "../../Containers/PopupAlert";

import Moment from "moment";

const initState = {
    visible: false,
    categorySectionList: [],
    categoryTitleList: [],
    totalVocabCount: null,
    classroomList: [],
    classroomStudentList: [],
    lastIndex: null
}

class PopupAdminHomework extends Component {
    state = {
        visible: false,
        categoryGradeList: [],
        categorySectionList: [],
        categoryTitleList: [],
        totalVocabCount: null,
        assignType: "요일별",
        classroomList: [],
        classroomStudentList: [],
        lastIndex: null,
        failAlert: false,
        failMessage: '',
        selectedSubject: 'vocabulary',
        isHwDone: true // reading 빈 칸 vocab 보여주기 여부로 사용 (임시)
    }

    // 마지막 vocab index, studentlist 보내기
    constructor(props) {
        super(props);
        this.subject = ['vocabulary', 'reading'];
        this.assignTypeList = ['요일별', '일일별'];
        this.ttsPlayOptionList = [1, 2, 3];
        this.cutlineOptionList = [0, 60, 70, 80];
        this.accumulativeCutlineOptionList = [0, 50, 60, 70, 80];
        this.examLimitTimeOptionList = [3, 5, 10, 30, 60, 300];
        this.classroomStudentTotalList = [];
        this.classrooms = ['학급선택'];
        this.weekdays = ['월', '화', '수', '목', '금', '토', '일'];
        this.selectedDate = Moment(new Date()).format('YYYY-MM-DD');
        this.startDate = Moment(new Date()).format('YYYY-MM-DD');
        this.endDate = Moment(new Date()).format('YYYY-MM-DD');
        this.selectedWeekDays = [];
        this.state.selectedSubject === 'vocabulary' ? this.getVocabCategory('categoryGradeList') : this.getReadingCategory('categoryGradeList')
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.state.visible != nextProps.active) {
            this.selectItem = nextProps.selectItem;
            this.isUpdateMode = nextProps.isUpdateMode;
            this.categoryGradeValue = (this.selectItem != null) ? this.selectItem.homework.grade : null;
            this.categorySectionValue = (this.selectItem != null) ? this.selectItem.homework.section : null;
            this.categoryTitleValue = (this.selectItem != null) ? this.selectItem.homework.title : null;
            this.selectedClassroom = (this.selectItem != null && this.selectItem.homework.classroom != null) ? this.selectItem.homework.classroom.classroomName : null;
            this.classroomValue = this.selectedClassroom;
            this.hwStartIndex = (this.selectItem != null) ? this.selectItem.homework.hwStartIndex : null;
            this.hwCountIndex = (this.selectItem != null) ? this.selectItem.homework.hwCountindex : null;
            this.readingBlankNum = (this.selectItem != null) ? this.selectItem.homework.readingBlankNum : null;
            this.selectedStudents = (this.selectItem != null) ? [].concat(this.selectItem.homework.user) : [];
            this.ttsPlayCountValue = (this.selectItem != null) ? this.selectItem.homework.ttsPlayCount : 1;
            this.accumulativeNum = (this.selectItem != null) ? this.selectItem.homework.accumulativeNum : 0;
            this.selectedDate = (this.selectItem != null) ? this.selectItem.homework.dueDate : null;
            this.cutlineValue = (this.selectItem != null) ? this.selectItem.homework.examCutline : 0;
            this.accumulativeCutlineValue = (this.selectItem != null) ? this.selectItem.homework.accumulativeCutline : 0;
            this.examTimeValue = (this.selectItem != null) ? this.selectItem.homework.examLimitTime : 5;
            this.startDate = Moment(new Date()).format('YYYY-MM-DD');
            this.endDate = Moment(new Date()).format('YYYY-MM-DD');
            this.setState({
                visible: nextProps.active,
                selectedSubject: nextProps.selectItem !== null ? nextProps.selectItem.homework.subject : this.subject[0],
                totalVocabCount: null,
                failAlert: false,
                assignType: (this.isUpdateMode) ? "일일별" : "요일별",
                classroomList: (this.selectItem == null || this.selectItem.homework.classroom == null) ? [] : [].concat(this.selectItem.homework.classroom.classroomName),
                classroomStudentList: (this.selectItem == null) ? [] : this.selectedStudents,
            });

            if (nextProps.active && this.isUpdateMode) {
                if (this.state.selectedSubject === 'vocabulary') {
                    this.getVocabCategory('categorySectionList', this.categoryGradeValue, null, () => {
                        this.getVocabCategory('categoryTitleList', this.categoryGradeValue, this.categorySectionValue, () => {
                            this.getLastIndex()
                        })
                    });
                } else if (this.state.selectedSubject === 'reading') {
                    this.getReadingCategory('categorySectionList', this.categoryGradeValue, null, () => {
                        this.getReadingCategory('categoryTitleList', this.categoryGradeValue, this.categorySectionValue, () => {
                            this.getLastIndex()
                        })
                    });
                }
            }
        }
    }

    componentDidMount = () => {
        this.getClassroomCategory();
    }

    setOptionAssignType = () => {
        return (<select onChange={this.handleAssignTypeChange}
                        disabled={this.selectedStudents.length == 0 || this.isUpdateMode} value={this.state.assignType}>
            {this.assignTypeList.map((value, i) => {
                return <option key={i} value={value}>{value}</option>
            })}
        </select>);
    }

    handleAssignTypeChange = (e) => {
        const assignType = e.target.value;
        if (assignType == '일일별') {
            this.selectedDate = this.startDate;
        } else {
            this.selectedDate = null;
        }
        this.selectedWeekDays = [];
        this.setState({assignType: e.target.value});
    }

    setOptionAssignTypeMapping = () => {
        const {assignType} = this.state;
        const date = (this.selectItem == null) ? Moment(new Date()).format('YYYY-MM-DD') : Moment(this.selectItem.homework.dueDate).format('YYYY-MM-DD');
        this.selectedDate = Moment(date).format('YYYY-MM-DD');
        return (
            <div className="box-date">
                {(assignType == '일일별') ?
                    <input type="date" defaultValue={date} onChange={this.changeDate}
                           readOnly={this.selectedStudents.length == 0}/>
                    : this.setWeekdayCheckbox()}
            </div>
        );
    }

    changeDate = (e) => {
        this.selectedDate = Moment(e.target.value).format('YYYY-MM-DD');
    }

    setWeekdayCheckbox = () => {
        return (
            <div>
                <div>
                    <input type="date" defaultValue={this.startDate} onChange={this.changeStartDate}
                           readOnly={this.selectedStudents.length == 0}/>
                    <span style={{display: this.state.selectedSubject === 'reading' ? 'none' : ''}}>>
                    <input type="date" defaultValue={this.endDate} onChange={this.changeEndDate}
                           readOnly={this.selectedStudents.length == 0}/>
                </span>
                </div>
                <div>
                    {this.weekdays.map((day, i) => {
                        return (
                            <div key={i} className="wrap-chbox">
                                <input type="checkbox" id={i} onChange={this.changeWeekdays}
                                       disabled={this.selectedStudents.length == 0}/>
                                <label htmlFor={i}>{day}</label>
                                <span></span>
                            </div>)
                    })}
                </div>
            </div>);
    }

    changeStartDate = (e) => {
        this.startDate = Moment(e.target.value).format('YYYY-MM-DD');
    }

    changeEndDate = (e) => {
        this.endDate = Moment(e.target.value).format('YYYY-MM-DD');
    }

    changeWeekdays = (e) => {
        if (e.target.checked == true)
            this.selectedWeekDays = this.selectedWeekDays.concat([].concat(e.target.id));
        else {
            const id = Utils.findIndex(this.selectedWeekDays, e.target.id);
            if (id >= 0) this.selectedWeekDays.splice(id, 1);
        }
    }

    changeHwStartIndex = (e) => {
        this.hwStartIndex = e.target.value;
    }

    changeReadingBlankNum = (e) => {
        this.readingBlankNum = e.target.value;
    }

    changeIsReadingBlankBoxDisplay = () => {
        this.setState({
            isHwDone: !this.state.isHwDone
        })
    }

    changeHwCountIndex = (e) => {
        this.hwCountIndex = e.target.value;
    }


    changeAccumulateExamVocabCount = (e) => {
        const {classroomStudentList} = this.state;
        this.accumulativeNum = (e.target.value == null || e.target.value.length == 0) ? 0 : e.target.value;
        this.setState({classroomStudentList: classroomStudentList});//강제 렌더링
    }

    handleCategoryChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.curPage = 0;
        this.setState({
            lastIndex: null,
            [name]: e.target.value,
            categorySectionList: (name == 'categoryGradeValue') ? [] : this.state.categorySectionList,
            categoryTitleList: (name == 'categoryGradeValue' || name == 'categorySectionValue') ? [] : this.state.categoryTitleList,
        });

        if (name == 'categoryGradeValue') {
            this.categoryGradeValue = (value == '대목차') ? null : value;
            this.categorySectionValue = null;
            this.categoryTitleValue = null;
            if (this.categoryGradeValue == null) {
                this.setState({
                    totalVocabCount: null,
                    categorySectionList: ['소목차'],
                    categoryTitleList: ['제목']
                });
                if (this.state.selectedSubject === 'vocabulary') {
                    this.getVocabList();
                } else if (this.state.selectedSubject === 'reading') {
                    this.getReadingList();
                }
            } else {
                if (this.state.selectedSubject === 'vocabulary') {
                    this.getVocabCategory('categorySectionList', this.categoryGradeValue, this.categorySectionValue);
                } else if (this.state.selectedSubject === 'reading') {
                    this.getReadingCategory('categorySectionList', this.categoryGradeValue, this.categorySectionValue);
                }
            }
        } else if (name == 'categorySectionValue') {
            this.categorySectionValue = (value == '소목차') ? null : value;
            this.categoryTitleValue = null;
            if (this.categorySectionValue == null) {
                this.setState({
                    categoryTitleList: ['제목']
                });
                if (this.state.selectedSubject === 'vocabulary') {
                    this.getVocabList();
                } else if (this.state.selectedSubject === 'reading') {
                    this.getReadingList();
                }
            } else {
                if (this.state.selectedSubject === 'vocabulary') {
                    this.getVocabCategory('categoryTitleList', this.categoryGradeValue, this.categorySectionValue);
                } else if (this.state.selectedSubject === 'reading') {
                    this.getReadingCategory('categoryTitleList', this.categoryGradeValue, this.categorySectionValue);
                }
            }
        } else if (name == 'categoryTitleValue') {
            this.categoryTitleValue = (value == '제목') ? null : value;
            if (this.state.selectedSubject === 'vocabulary') {
                this.getVocabList();
            } else if (this.state.selectedSubject === 'reading') {
                this.getReadingList();
            }
            if (this.state.selectedSubject === 'vocabulary' && this.selectedStudents.length > 0 && this.categoryTitleValue != null) {
                this.getLastIndex();
            }
        }
    }

    setOptionCategorySelectBox = (category) => {
        return (<div className="wrap-select">
            <span></span>
            <select name={[category]} disabled={this.selectedStudents.length == 0} onChange={this.handleCategoryChange}
                    value={this.getDefaultCategoryValue(category)}>
                {this.setOptionMappingValue(category)}
            </select>
        </div>);
    }

    getDefaultCategoryValue = (category) => {
        if (category == 'categoryGradeValue') {
            return (this.categoryGradeValue == null) ? '대목차' : this.categoryGradeValue;
        } else if (category == 'categorySectionValue') {
            return (this.categorySectionValue == null) ? '소목차' : this.categorySectionValue;
        } else {
            return (this.categoryTitleValue == null) ? '제목' : this.categoryTitleValue;
        }
    }

    setOptionMappingValue = (category) => {
        const {categoryGradeList, categorySectionList, categoryTitleList} = this.state;
        if (category == 'categoryGradeValue')
            return categoryGradeList.map((grade, i) => {
                return <option key={i} value={grade}>{grade}</option>
            });
        else if (category == 'categorySectionValue')
            return categorySectionList.map((section, i) => {
                return <option key={i} value={section}>{section}</option>
            });
        else
            return categoryTitleList.map((title, i) => {
                return <option key={i} value={title}>{title}</option>
            });
    }

    setOptionTTSPlayCount = () => {
        return (<select value={this.ttsPlayCountValue} onChange={this.onTTSPlayCount}
                        disabled={this.selectedStudents.length == 0}>
            {this.ttsPlayOptionList.map((value, i) => {
                return <option key={i} value={value}>{value + '회'}</option>
            })}
        </select>);
    }

    onTTSPlayCount = (e) => {
        const {classroomStudentList} = this.state;
        this.ttsPlayCountValue = e.target.value;
        this.setState({classroomStudentList: classroomStudentList});//강제 렌더링
    }

    setOptionExamCutline = () => {
        return (<select value={this.cutlineValue} onChange={this.onChangeExamCutline}
                        disabled={this.selectedStudents.length == 0}>
            {this.cutlineOptionList.map((value, i) => {
                return <option key={i} value={value}>{(value == 0) ? '선택없음' : value + '점'}</option>
            })}
        </select>);
    }

    onChangeExamCutline = (e) => {
        const {classroomStudentList} = this.state;
        this.cutlineValue = e.target.value;
        this.setState({classroomStudentList: classroomStudentList});//강제 렌더링
    }

    setOptionAccumulativeCutline = () => {
        return (<select value={this.accumulativeCutlineValue} onChange={this.onChangeAccumulativeCutline}
                        disabled={this.selectedStudents.length == 0}>
            {this.accumulativeCutlineOptionList.map((value, i) => {
                return <option key={i} value={value}>{(value == 0) ? '선택없음' : value + '점'}</option>
            })}
        </select>);
    }

    onChangeAccumulativeCutline = (e) => {
        const {classroomStudentList} = this.state;
        this.accumulativeCutlineValue = e.target.value;
        this.setState({classroomStudentList: classroomStudentList});//강제 렌더링
    }

    setOptionExamTime = () => {
        return (<select value={this.examTimeValue} onChange={this.onChangeExamTime}
                        disabled={this.selectedStudents.length == 0}>
            {this.examLimitTimeOptionList.map((value, i) => {
                return <option key={i} value={value}>{value + '초'}</option>
            })}
        </select>);
    }

    onChangeExamTime = (e) => {
        const {classroomStudentList} = this.state;
        this.examTimeValue = e.target.value;
        this.setState({classroomStudentList: classroomStudentList});//강제 렌더링
    }

    getVocabCategory = (category, grade, section, callback) => {
        AdminHomeworkService.getVocabCategoryList(grade, section).then((response) => {
            if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
                let dataList = [];
                dataList = response.data.data;

                let unshiftChar = (category === 'categoryGradeList') ? '대목차' : (category === 'categorySectionList') ? '소목차' : '제목';
                dataList.unshift(unshiftChar);

                if (category !== 'categorySectionList' || grade != null)
                    this.getVocabList();

                this.setState({
                    totalVocabCount: null,
                    categorySectionList: (category === 'categoryGradeList') ? ['소목차'] : this.state.categorySectionList,
                    categoryTitleList: (category !== 'categoryTitleList') ? ['제목'] : this.state.categoryTitleList,
                    [category]: dataList,
                });

                if (callback != null)
                    callback();
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    getReadingCategory = (category, grade, section, callback) => {
        AdminHomeworkService.getReadingCategoryList(grade, section).then((response) => {
            if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
                let dataList = [];
                dataList = response.data.data;

                let unshiftChar = (category === 'categoryGradeList') ? '대목차' : (category === 'categorySectionList') ? '소목차' : '제목';
                dataList.unshift(unshiftChar);

                if (category !== 'categorySectionList' || grade != null)
                    this.getReadingList();

                this.setState({
                    totalVocabCount: null,
                    categorySectionList: (category === 'categoryGradeList') ? ['소목차'] : this.state.categorySectionList,
                    categoryTitleList: (category !== 'categoryTitleList') ? ['제목'] : this.state.categoryTitleList,
                    [category]: dataList,
                });

                if (callback != null)
                    callback();
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    getVocabList = () => {
        if (this.categorySectionValue == '소제목') {
            this.categorySectionValue = null;
            this.categoryTitleValue = null;
        } else if (this.categoryTitleValue == '제목') {
            this.categoryTitleValue = null;
        }

        AdminHomeworkService.getVocabsCount(this.categoryGradeValue, this.categorySectionValue, this.categoryTitleValue).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.setState({totalVocabCount: responseData.data});
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert("SERVER ERROR");
        });
    }

    getReadingList = () => {
        if (this.categorySectionValue == '소제목') {
            this.categorySectionValue = null;
            this.categoryTitleValue = null;
        } else if (this.categoryTitleValue == '제목') {
            this.categoryTitleValue = null;
        }

        AdminHomeworkService.getReadingCount(this.categoryGradeValue, this.categorySectionValue, this.categoryTitleValue).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.setState({totalVocabCount: responseData.data});
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert("SERVER ERROR");
        });
    }

    getStudentNameList = () => {
        const {classroomStudentList} = this.state;
        let studentNames = '';
        for (let i = 0; i < classroomStudentList.length; i++) {
            if (i > 0) studentNames += ',';
            studentNames += classroomStudentList[i].username;
        }
        return studentNames;
    }

    getSelectedStudentsNameList = () => {
        let studentNames = '';
        for (let i = 0; i < this.selectedStudents.length; i++) {
            if (i > 0) studentNames += ',';
            studentNames += this.selectedStudents[i].username;
        }
        return studentNames;
    }

    getLastIndex = () => {
        console.log(this.state.selectedSubject);
        AdminHomeworkService.getHomeworkLastIndex(this.getStudentNameList(), this.categoryGradeValue, this.categorySectionValue, this.categoryTitleValue, this.state.selectedSubject).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.setState({lastIndex: responseData.data});
                } else if (responseData.code === '0001') {
                    this.setState({lastIndex: 0});
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            console.log(response);
            alert("SERVER ERROR");
        });
    }

    getClassroomCategory = () => {
        AdminClassroomService.getClassroomCategory().then((response) => {
            if (response !== null && response.status === 200) {
                let temp = this.classrooms;
                temp = temp.concat(response.data.data);
                this.classrooms = temp;
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    getStudentList = (className) => {
        AdminClassroomService.getStudentList(className).then((response) => {
            if (response !== null && response.status === 200) {
                this.classroomStudentTotalList = response.data.data;
                // console.log([].concat(this.classroomValue));
                this.setState({
                    classroomStudentList: response.data.data,
                    classroomList: [].concat(this.classroomValue)
                });
            }

        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    onChangeClassroomOption = (e) => {
        this.classroomValue = (e.target.value == '학급선택') ? null : e.target.value;

        if (e.target.value == '학급선택')
            this.setState({classroomStudentList: []});
        else
            this.getStudentList(e.target.value);
    }

    setClassroom = () => {
        if (!this.isUpdateMode)
            return (<select onChange={this.onChangeClassroomOption}>
                {this.classrooms.map((classroomName, i) => {
                    return <option key={i}>{classroomName}</option>
                })}
            </select>);
        else
            return (<div className="wrap-search">
                <input className="ip-basic" type="text" value={this.selectedClassroom} readOnly={true}/>
            </div>);
    }

    setSubject = () => {
        if (!this.isUpdateMode) {
            return (
                <select disabled={this.selectedStudents.length === 0} onChange={this.changeSubject}>
                    {this.subject.map((value, i) => {
                        return <option key={i} value={value}>{value}</option>
                    })}
                </select>
            );
        } else {
            return (
                <div className="wrap-search">
                    <input className="ip-basic" type="text" value={this.state.selectedSubject} readOnly={true}/>
                </div>
            );
        }
    };

    changeSubject = (e) => {
        this.setState({
            selectedSubject: e.target.value,
            categoryGradeList: ['대목차'],
            categorySectionList: ['소목차'],
            categoryTitleList: ['제목']
        });
        this.categoryGradeValue = null;
        this.categorySectionValue = null;
        this.categoryTitleValue = null;
        if (e.target.value === 'vocabulary') {
            this.getVocabCategory('categoryGradeList');
        } else if (e.target.value === 'reading') {
            this.getReadingCategory('categoryGradeList');
        }
    };

    //단어로 검색
    onSearch = (event) => {
        if (event == null || (event != null && event.key == 'Enter')) {
            const list = (this.inputValue == null || this.inputValue.length == 0) ? this.classroomStudentTotalList : this.classroomStudentTotalList.filter((x) => {
                // return x.username == this.inputValue
                return x.username.indexOf(this.inputValue) != -1;
            });
            this.setState({classroomStudentList: list});
        } else {
            return false;
        }
    }

    // input 데이터 저장
    onInputValueChanged = (e) => {
        if (e.target.value == '') {
            this.inputValue = null;
        } else {
            this.inputValue = e.target.value
        }
    }

    checkGroup = (e) => {
        const {classroomStudentList} = this.state;

        for (let i = 0; i < classroomStudentList.length; i++) {
            classroomStudentList[i].checked = e.target.checked;
        }

        this.selectedStudents = classroomStudentList.filter(x => x.checked);
        this.setState({classroomStudentList: classroomStudentList, lastIndex: null});

        if (this.selectedStudents.length > 0 && this.categoryGradeValue != null
            && this.categorySectionValue != null && this.categoryTitleValue != null)
            this.getLastIndex();
    }

    checkItem = (index, checked) => {
        const {classroomStudentList} = this.state;
        classroomStudentList[index].checked = checked;
        this.selectedStudents = classroomStudentList.filter(x => x.checked);
        this.setState({classroomStudentList: classroomStudentList, lastIndex: null});

        if (this.selectedStudents.length > 0 && this.categoryGradeValue != null
            && this.categorySectionValue != null && this.categoryTitleValue != null)
            this.getLastIndex();
    }

    checkValidateVocab = () => {
        const {assignType} = this.state;
        let resultVO = {result: false, message: ''};
        if (this.selectedStudents.length === 0) {
            resultVO.message = '숙제를 부여할 학생을 선택하세요.';
        } else if (this.categoryGradeValue == null) {
            resultVO.message = '대목차를 선택하세요.';
        } else if (this.categorySectionValue == null) {
            resultVO.message = '소목차를 선택하세요.';
        } else if (this.categoryTitleValue == null) {
            resultVO.message = '제목을 선택하세요.';
        } else if (this.hwStartIndex == null) {
            resultVO.message = '숙제 시작 번호를 입력하세요.';
        } else if (this.hwCountIndex == null) {
            resultVO.message = '부여할 숙제 단어 수를 지정하세요.';
        } else if (this.hwCountIndex * 1 < 5) {
            resultVO.message = '부여할 숙제 단어 수는 5개 이상 설정하세요.';
        } else if (this.accumulativeNum * 1 !== 0 && (this.accumulativeNum * 1 < 5)) {
            resultVO.message = '누적 시험 단어수는 5개 이상 설정하세요'
        } else if (assignType === '요일별' && this.selectedWeekDays.length === 0) {
            resultVO.message = '숙제를 부여할 날짜를 지정하세요.';
        } else {
            resultVO.result = true;
        }
        // console.log(resultVO);
        return resultVO;
    };

    checkValidateReading = () => {
        const {assignType} = this.state;
        let resultVO = {result: false, message: ''};
        if (this.selectedStudents.length === 0) {
            resultVO.message = '숙제를 부여할 학생을 선택하세요.';
        } else if (this.categoryGradeValue == null) {
            resultVO.message = '대목차를 선택하세요.';
        } else if (this.categorySectionValue == null) {
            resultVO.message = '소목차를 선택하세요.';
        } else if (this.state.assignType !== '요일별' && this.categoryTitleValue == null) {
            resultVO.message = '제목을 선택하세요.';
        } else if (this.readingBlankNum == null) {
            resultVO.message = '빈 칸 수를 넣어주세요.';
        } else if (assignType === '요일별' && this.selectedWeekDays.length === 0) {
            resultVO.message = '숙제를 부여할 날짜를 지정하세요.';
        } else {
            resultVO.result = true;
        }
        // console.log(resultVO);
        return resultVO;
    };

    onSubmit = () => {
        let resultVO = null;
        if (this.state.selectedSubject === 'vocabulary') {
            resultVO = this.checkValidateVocab();
        } else if (this.state.selectedSubject === 'reading') {
            resultVO = this.checkValidateReading();
        } else {
            resultVO.result = false;
            resultVO.message = 'ERROR';
        }
        if (!resultVO.result) {
            this.setState({failAlert: true, failMessage: resultVO.message});
        } else {
            const homework = {
                "dueDate": this.selectedDate,
                "grade": this.categoryGradeValue,
                "section": this.categorySectionValue,
                "title": this.categoryTitleValue,
                "subject": this.state.selectedSubject,
                "hwCountindex": this.hwCountIndex,
                "hwCreatedBy": "test",
                "hwDone": this.state.selectedSubject === 'reading' ? this.state.isHwDone : "false",
                "hwEndIndex": (this.hwStartIndex * 1 + this.hwCountIndex * 1) - 1,
                "hwStartIndex": this.hwStartIndex,
                "hwUpdatedBy": "test",
                "ttsPlayCount": this.ttsPlayCountValue,
                "accumulativeNum": this.accumulativeNum,
                "examCutline": this.cutlineValue,
                "examLimitTime": this.examTimeValue,
                "accumulativeCutline": this.accumulativeCutlineValue,
                "readingBlankNum": this.readingBlankNum
            };
            AdminHomeworkService.insertHomework(homework, this.getSelectedStudentsNameList(), this.classroomValue, this.getWeekDaysList(), this.startDate, this.endDate).then((response) => {
                if (response.status === 200) {
                    let responseData = response.data;
                    if (responseData.code === '0000') {
                        this.setState(initState);
                        this.selectedWeekDays = [];
                        this.selectedStudents = [];
                        this.props.onClose();
                    } else {
                        this.setState({failAlert: true, failMessage: responseData.data});
                    }
                } else {
                    alert('GET HOMEWORK ERROR');
                }
            }).catch(response => {
                console.log(response);
                alert("SERVER ERROR");
            });
        }
    }

    getWeekDaysList = () => {
        let weekDays = '';
        for (let i = 0; i < this.selectedWeekDays.length; i++) {
            if (i > 0) weekDays += ',';
            weekDays += this.selectedWeekDays[i];
        }

        return weekDays;
    }

    onUpdate = () => {
        let resultVO = null;
        if (this.state.selectedSubject === 'vocabulary') {
            resultVO = this.checkValidateVocab();
        } else if (this.state.selectedSubject === 'reading') {
            resultVO = this.checkValidateReading();
        } else {
            resultVO.result = false;
            resultVO.message = 'ERROR';
        }
        if (!resultVO.result) {
            this.setState({failAlert: true, failMessage: resultVO.message});
        } else {
            const homework = {
                "id": this.selectItem.homework.id,
                "dueDate": this.selectedDate,
                "grade": this.categoryGradeValue,
                "section": this.categorySectionValue,
                "title": this.categoryTitleValue,
                "subject": this.state.selectedSubject,
                "hwCountindex": this.hwCountIndex,
                "hwCreatedBy": "test",
                "hwDone": false,
                "hwEndIndex": (this.hwStartIndex * 1 + this.hwCountIndex * 1) - 1,
                "hwStartIndex": this.hwStartIndex,
                "hwUpdatedBy": "test",
                "ttsPlayCount": this.ttsPlayCountValue,
                "accumulativeNum": this.accumulativeNum,
                "classroom": this.selectItem.homework.classroom,
                "examCutline": this.cutlineValue,
                "examLimitTime": this.examTimeValue,
                "accumulativeCutline": this.accumulativeCutlineValue,
                "readingBlankNum": this.readingBlankNum
            };
            AdminHomeworkService.updateHomework(homework, this.selectedStudents[0].username).then((response) => {
                if (response.status === 200) {
                    let responseData = response.data;
                    if (responseData.code === '0000') {
                        this.setState(initState);
                        this.selectedWeekDays = [];
                        this.selectedStudents = [];
                        this.props.onClose();
                    } else {
                        this.setState({failAlert: true, failMessage: responseData.data});
                    }
                } else {
                    alert('GET HOMEWORK ERROR');
                }
            }).catch((error) => {
                console.log(error);
                alert('SERVER ERROR');
            });
        }
        //this.props.onClose();
    }

    onDelete = () => {
        AdminHomeworkService.deleteHomework(this.selectItem.homework.id)
            .then((response) => {
                if (response !== null && response.status === 200) {
                    this.setState(initState);
                    this.selectedWeekDays = [];
                    this.selectedStudents = [];
                    this.props.onClose();
                }
            }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    popupConfirm = () => {
        this.setState({failAlert: false, failMessage: ''});
    }

    render() {
        const {visible, lastIndex, failAlert, failMessage} = this.state;
        const {isUpdateMode, onClose} = this.props;
        return (
            visible ?
                <div className="popupWrapper admin">
                    <div className="popup">
                        <div className="formWrapper">
                            <div className="joinForm">
                                <fieldset>
                                    <legend className="screenOut">{(isUpdateMode) ? '숙제 상세' : '숙제 부여'}</legend>
                                    <dl className="formContents">
                                        <dt className="title">
                                            <span>{(isUpdateMode) ? '숙제 상세' : '숙제 부여'}</span>
                                            <button onClick={onClose} className="btnClose">닫기</button>
                                        </dt>
                                        <dd className="contents">
                                            <div className="tabContents">
                                                <ul>
                                                    <li>
                                                        <div className="inputWrapper">
                                                            <ul>
                                                                <li>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*학급명</span>
                                                                          {this.setClassroom()}
                                                                          {!isUpdateMode &&
                                                                              <div className="wrap-search">
                                                                                  <input className="ip-basic"
                                                                                         type="text"
                                                                                         placeholder="학생 이름 검색"
                                                                                         onChange={this.onInputValueChanged}
                                                                                         onKeyPress={this.onSearch}/>
                                                                                  <a className="btn-sm yellow"
                                                                                     onClick={() => this.onSearch()}>검색</a>
                                                                              </div>}
                                                                      </label>
                                                                  </span>
                                                                </li>
                                                                <li className={this.state.classroomStudentList.length === 0 ? "box-student type-none" : "box-student"}>
                                                                    <table className="tb-basic">
                                                                        <colgroup>
                                                                            {(!isUpdateMode) && <col width="5%"/>}
                                                                            <col width="15%"/>
                                                                            <col width="15%"/>
                                                                            <col width="15%"/>
                                                                            <col width="10%"/>
                                                                            <col width="10%"/>
                                                                        </colgroup>
                                                                        <thead>
                                                                        <tr>
                                                                            {!isUpdateMode &&
                                                                                <th>
                                                                                    <div className="wrap-chbox">
                                                                                        <input type="checkbox"
                                                                                               onChange={this.checkGroup}/>
                                                                                        <span></span>
                                                                                    </div>
                                                                                </th>}
                                                                            <th>학교</th>
                                                                            <th>학년</th>
                                                                            <th>학급명</th>
                                                                            <th>이름</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {this.state.classroomStudentList.map((item, i) => {
                                                                            return (
                                                                                <tr key={i}>
                                                                                    {!isUpdateMode &&
                                                                                        <td>
                                                                                            <div className="wrap-chbox">
                                                                                                <input type="checkbox"
                                                                                                       checked={(item.checked === undefined) ? false : item.checked}
                                                                                                       onChange={(e) => this.checkItem(i, e.target.checked)}/>
                                                                                                <span></span>
                                                                                            </div>
                                                                                        </td>}
                                                                                    <td>{item.school}</td>
                                                                                    <td>{item.grade}</td>
                                                                                    <td>{this.classroomValue}</td>
                                                                                    <td>{item.name}</td>
                                                                                </tr>)
                                                                        })}
                                                                        </tbody>
                                                                    </table>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*과목</span>
                                                                          {this.setSubject()}
                                                                      </label>
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*대목차</span>
                                                                          {this.setOptionCategorySelectBox('categoryGradeValue')}
                                                                      </label>
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*소목차</span>
                                                                          {this.setOptionCategorySelectBox('categorySectionValue')}
                                                                      </label>
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label
                                                                          style={{display: this.state.selectedSubject === 'reading' && this.state.assignType === '요일별' ? 'none' : ''}}>
                                                                          <span>*제목</span>
                                                                          {this.setOptionCategorySelectBox('categoryTitleValue')}
                                                                      </label>
                                                                      {(this.state.totalVocabCount != null) &&
                                                                          <span className="txt-info">
                                                                            총 수<em>{this.state.totalVocabCount}</em>개
                                                                        </span>}
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'vocabulary' ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*숙제 시작 번호</span>
                                                                          <input type="number"
                                                                                 placeholder={(this.hwStartIndex == null) ? 1 : this.hwStartIndex}
                                                                                 defaultValue={(this.hwStartIndex == null) ? '' : this.hwStartIndex}
                                                                                 readOnly={this.selectedStudents.length == 0}
                                                                                 onChange={this.changeHwStartIndex}/>
                                                                      </label>
                                                                  </span>
                                                                    {<span
                                                                        className="txt-info">마지막 숙제 부여 번호<em>{(lastIndex == null) ? '-' : lastIndex}</em>번</span>}
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'vocabulary' ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*부여할 숙제 단어 수</span>

                                                                          <input type="number"
                                                                                 defaultValue={(this.selectItem == null) ? '' : this.selectItem.homework.hwCountindex}
                                                                                 placeholder={(this.selectItem == null) ? 20 : this.selectItem.homework.hwCountindex}
                                                                                 readOnly={this.selectedStudents.length === 0}
                                                                                 onChange={this.changeHwCountIndex}/>
                                                                      </label>
                                                                      <span className="txt-info">시험 커트라인</span>
                                                                      <label>{this.setOptionExamCutline()}</label>
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'reading' ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*시험 커트라인</span>
                                                                          <label>{this.setOptionExamCutline()}</label>
                                                                      </label>
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'reading' ? {display: 'block'} : {display: 'none'}}>
                                                                    <span className="customInputBox">
                                                                      <label>
                                                                          <span>*빈 칸 수</span>
                                                                          <input type="number"
                                                                                 placeholder={(this.readingBlankNum == null) ? 1 : this.readingBlankNum}
                                                                                 defaultValue={(this.readingBlankNum == null) ? '' : this.readingBlankNum}
                                                                                 readOnly={this.selectedStudents.length == 0}
                                                                                 onChange={this.changeReadingBlankNum}/>
                                                                      </label>
                                                                    </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'reading' ? {display: 'block'} : {display: 'none'}}>
                                                                    <span className="customInputBox">
                                                                      <label>
                                                                          <span>*빈 칸 단어 박스 활성화 여부</span>
                                                                          <input style={{
                                                                              position: 'relative',
                                                                              right: '10%'
                                                                          }}
                                                                                 type="checkbox"
                                                                                 checked={this.state.isHwDone}
                                                                                 onChange={() => this.changeIsReadingBlankBoxDisplay()}/>
                                                                      </label>
                                                                    </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'vocabulary' ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>누적 시험 단어 제출 수</span>
                                                                          <input type="number"
                                                                                 placeholder={(this.accumulativeNum > 1) ? this.accumulativeNum : 0}
                                                                                 defaultValue={(this.accumulativeNum > 1) ? this.accumulativeNum : (this.selectItem == null) ? '' : 0}
                                                                                 readOnly={this.selectedStudents.length === 0}
                                                                                 onChange={this.changeAccumulateExamVocabCount}/>
                                                                      </label>
                                                                      {(this.accumulativeNum > 0) &&
                                                                          <span className="txt-info">누적시험 커트라인</span>}
                                                                      {(this.accumulativeNum > 0) &&
                                                                          <label>{this.setOptionAccumulativeCutline()}</label>}
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'vocabulary' ? {display: 'block'} : {display: 'none'}}>
                                                                    <span className="customInputBox">
                                                                        <label>
                                                                            <span>*시험 시간</span>
                                                                            {this.setOptionExamTime()}
                                                                        </label>
                                                                    </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 && this.state.selectedSubject === 'vocabulary' ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*발음 재생 횟수</span>
                                                                          {this.setOptionTTSPlayCount()}
                                                                      </label>
                                                                  </span>
                                                                </li>
                                                                <li style={this.selectedStudents.length !== 0 ? {display: 'block'} : {display: 'none'}}>
                                                                  <span className="customInputBox">
                                                                      <label>
                                                                          <span>*숙제 부여</span>
                                                                          {/*{this.state.selectedSubject === 'vocabulary' ? this.setOptionAssignType() : null}*/}
                                                                          {this.setOptionAssignType()}
                                                                      </label>
                                                                      {this.setOptionAssignTypeMapping()}
                                                                  </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="btnWrapper">
                                                            {(isUpdateMode) ?
                                                                <div>
                                                                    <span
                                                                        style={{display: this.state.selectedSubject === 'reading' ? 'none' : ''}}>
                                                                        <BaseBtn btnColor="blue" btnName={"수정"}
                                                                                 onClick={this.onUpdate}/>
                                                                    </span>
                                                                    <BaseBtn btnColor="deepPink" btnName={"삭제"}
                                                                             onClick={this.onDelete}/>
                                                                </div>
                                                                : <BaseBtn btnColor="deepPink" btnName="확인"
                                                                           onClick={this.onSubmit}/>}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </dd>
                                    </dl>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    {<PopupAlert active={failAlert} message={failMessage} onConfirm={this.popupConfirm}/>}
                </div> : null
        );
    }
}

PopupAdminHomework.defaultProps = {
    selectItem: null,
    ttsPlayCount: 1
}
export default PopupAdminHomework;



// WEBPACK FOOTER //
// ./src/components/Containers/PopupAdminHomework/index.js